export const environment = {
    production: false,
    baseUrl: 'https://aquapassapidev.pozitivehub.com/api/',
    createdby: 1,
    EncryptKey: 'z10ds5797a4e4423bbce3ea1024a1817',
    EncryptIV: 'z10ds5797a4e4423bbce3ea1024a1817',
    creditscorekey : 0,
    ticketingUrl: 'https://aquapaasticketing.pozitivehub.com/',
};
